var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCamera = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.83 7H20C21.1046 7 22 7.89543 22 9V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V9C2 7.89543 2.89543 7 4 7H5.17C5.70304 7.00042 6.2142 6.78804 6.59 6.41L8.12 4.88C8.68207 4.31723 9.44462 4.0007 10.24 4H13.76C14.5554 4.0007 15.3179 4.31723 15.88 4.88L17.41 6.41C17.7858 6.78804 18.297 7.00042 18.83 7ZM8 13C8 15.2091 9.79086 17 12 17C13.0609 17 14.0783 16.5786 14.8284 15.8284C15.5786 15.0783 16 14.0609 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCamera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Camera.4d53eb2a.svg";
export { ForwardRef as ReactComponent };